/**
 * Theme: Hyper - Responsive Bootstrap 5 Admin Dashboard
 * Author: Coderthemes
 * Module/App: Theme Config Js
 */

(function () {
    try {
        var cgUiVersion = "2026-05-design-system-v1";
        if (localStorage.getItem("CONSULTE_GEO_UI_VERSION") !== cgUiVersion) {
            sessionStorage.removeItem("__HYPER_CONFIG__");
            localStorage.setItem("CONSULTE_GEO_UI_VERSION", cgUiVersion);
        }
    } catch (e) {}
  var savedConfig = sessionStorage.getItem('__HYPER_CONFIG__');
  // var savedConfig = localStorage.getItem("__HYPER_CONFIG__");

  var html = document.getElementsByTagName('html')[0];

  //  Default Config Value
  var defaultConfig = {
    theme: 'light',

    nav: 'vertical',

    layout: {
      mode: 'fluid',
      position: 'fixed'
    },

    topbar: {
            color: "brand",
        },

    // This option for only vertical (left Sidebar) layout
    sidenav: {
      color: 'light',
      size: 'default',
      user: false
    }
  };

  let config = Object.assign(JSON.parse(JSON.stringify(defaultConfig)), {});

  var layoutColor = html.getAttribute('data-theme');
  config['theme'] = layoutColor !== null ? layoutColor : defaultConfig.theme;

  var layoutNav = html.getAttribute('data-layout');
  config['nav'] = layoutNav !== null ? (layoutNav === 'topnav' ? 'horizontal' : 'vertical') : defaultConfig.nav;

  var layoutSize = html.getAttribute('data-layout-mode');
  config['layout']['mode'] = layoutSize !== null ? layoutSize : defaultConfig.layout.mode;

  var layoutMode = html.getAttribute('data-layout-position');
  config['layout']['position'] = layoutMode !== null ? layoutMode : defaultConfig.layout.position;

  var topbarColor = html.getAttribute('data-topbar-color');
  config['topbar']['color'] = topbarColor != null ? topbarColor : defaultConfig.topbar.color;

  var leftbarColor = html.getAttribute('data-sidenav-color');
  config['sidenav']['color'] = leftbarColor !== null ? leftbarColor : defaultConfig.sidenav.color;

  var leftbarSize = html.getAttribute('data-sidenav-size');
  config['sidenav']['size'] = leftbarSize !== null ? leftbarSize : defaultConfig.sidenav.size;

  var sidebarUser = html.getAttribute('data-sidenav-user');
  config['sidenav']['user'] = sidebarUser !== null ? true : defaultConfig.sidenav.user;

  window.defaultConfig = JSON.parse(JSON.stringify(config));

  if (savedConfig !== null) {
    config = JSON.parse(savedConfig);
  }

  window.config = config;

  if (html.getAttribute('data-layout') === 'topnav') {
    config.nav = 'horizontal';
  } else {
    config.nav = 'vertical';
  }

  if (config) {
    html.setAttribute('data-theme', config.theme);
    html.classList.remove('light-mode', 'dark-mode');
    html.classList.add(config.theme + '-mode');
    html.setAttribute('data-layout-mode', config.layout.mode);
    html.setAttribute('data-topbar-color', config.topbar.color);
    if (config.nav == 'vertical') {
      html.setAttribute('data-sidenav-size', config.sidenav.size);
      html.setAttribute('data-sidenav-color', config.sidenav.color);
      html.setAttribute('data-layout-position', config.layout.position);
      if (config.sidenav.user && config.sidenav.user.toString() === 'true') {
        html.setAttribute('data-sidenav-user', true);
      } else {
        html.removeAttribute('data-sidenav-user');
      }
    }
  }
})();
